<template>

    <v-form
        ref='require-info-form'
        lazy-validation
        v-model='validRequiredInfo'
        :disabled='loadingSubmitRequiredInfo'
        @submit.prevent='submitRequiredApartmentInfo()'
    >

        <!--global attributes-->
        <v-row>
            <v-col cols='12'>
                <InfoAlert>
                    <ul class='pl-0 pr-4'>
                        <li>اطلاعات مجموعه خود را به درستی مطابق با مدارک مجموعه تکمیل کنید.</li>
                    </ul>
                </InfoAlert>
            </v-col>
            <v-col cols='6' md='4'>
                <v-select
                    v-model='apartment.type'
                    :rules='rules.type'
                    :items='typeOptions'
                    item-text='title'
                    item-value='key'
                    no-data-text='یافت نشد'
                    required
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>
                        نوع مجموعه
                    </template>
                </v-select>
            </v-col>
            <!--title-->
            <v-col cols='6' md='4'>
                <v-text-field
                    v-model='apartment.title'
                    :rules='rules.title'
                    placeholder='به طور مثال ساحل '
                    persistent-hint
                    required
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>عنوان
                    </template>
                </v-text-field>
            </v-col>
            <!--practical-->
            <v-col cols='6' md='4'>
                <v-select
                    v-model='apartment.practical'
                    :items='practicalOptions'
                    :rules='rules.practical'
                    required
                    item-text='title'
                    item-value='key'
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>کاربری
                    </template>
                </v-select>
            </v-col>
            <!--province-->
            <v-col cols='6' md='4'>
                <v-autocomplete
                    v-model='apartment.province'
                    :rules='rules.province'
                    :items='provinceOptions'
                    item-text='title'
                    item-value='_id'
                    no-data-text='یافت نشد'
                    required
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>استان
                    </template>
                </v-autocomplete>
            </v-col>
            <!--city-->
            <v-col cols='6' md='4'>
                <v-autocomplete
                    v-model='apartment.city'
                    :rules='rules.city'
                    :items='cityOptions'
                    item-text='title'
                    item-value='_id'
                    no-data-text='موردی یافت نشد'
                    required
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>شهر
                    </template>
                </v-autocomplete>
            </v-col>
            <!--address-->
            <v-col cols='12' sm='6' md='4'>
                <v-text-field
                    v-model='apartment.address'
                    :rules='rules.address'
                    required
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>آدرس
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <!--TOWN attributes-->
        <v-row v-if='apartment.type==="TOWN"'>
            <!--pieceCount-->
            <v-col cols='6' md='4'>
                <v-text-field
                    v-model='apartment.pieceCount'
                    :rules='rules.pieceCount'
                    type='number'
                    required
                    hint='لطفا کیبورد خود را انگلیسی کنید'
                    persistent-hint
                    :disabled='disabled'
                    min='1'
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>تعداد کل قطعه ها
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <!--APARTMENT | TOWER | COMPLEX attributes-->
        <v-row v-else>
            <!--number-->
            <v-col cols='6' md='4'>
                <v-text-field
                    v-model='apartment.number'
                    :rules='rules.number'
                    hint='لطفا کیبورد خود را انگلیسی کنید'
                    persistent-hint
                    type='number'
                    required
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>پلاک
                    </template>
                </v-text-field>
            </v-col>
            <!--postalCode-->
            <v-col cols='6' md='4'>
                <v-text-field
                    v-model='apartment.postalCode'
                    :rules='rules.postalCode'
                    type='number'
                    label='کد پستی'
                    hint='لطفا کیبورد خود را انگلیسی کنید'
                    persistent-hint
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'

                ></v-text-field>
            </v-col>

            <!--floorCount-->
            <v-col cols='6' md='4'>
                <v-text-field
                    v-model='apartment.floorCount'
                    :rules='rules.floorCount'
                    type='number'
                    hint='لطفا کیبورد خود را انگلیسی کنید'
                    persistent-hint
                    required
                    :disabled='disabled'
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>تعداد طبقه
                    </template>
                </v-text-field>
            </v-col>
            <!--unitCount-->
            <v-col cols='6' md='4'>
                <v-text-field
                    v-model='apartment.unitCount'
                    :rules='rules.unitCount'
                    type='number'
                    required
                    hint='لطفا کیبورد خود را انگلیسی کنید'
                    persistent-hint
                    :disabled='disabled'
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        <span class='red--text'><strong>* </strong></span>تعداد کل واحدها
                    </template>
                </v-text-field>
            </v-col>
            <!--blockCount-->
            <v-col cols='6' md='4'>
                <v-text-field
                    v-model='apartment.blockCount'
                    type='number'
                    required
                    hint='لطفا کیبورد خود را انگلیسی کنید'
                    persistent-hint
                    :disabled='disabled'
                    @focus='hideNavigationBar'
                    @blur='showNavigationBar'
                >
                    <template #label>
                        تعداد بلوک‌ها
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <!--submit btn-->
        <v-row>
            <v-col cols='12'>
                <v-card-actions class='pa-0'>
                    <v-spacer/>
                    <v-btn
                        :loading='loadingSubmitRequiredInfo'
                        :disabled='loadingSubmitRequiredInfo || !validRequiredInfo'
                        name='submit'
                        color='primary'
                        type='submit'
                        @click='validateApartmentInfo'
                    >ثبت
                    </v-btn>
                </v-card-actions>

            </v-col>
        </v-row>
        <v-dialog
            v-model='showInvalidMessageDialog'
            width='500'

        >
            <v-sheet style='overflow: hidden'>
                <v-alert class='mb-0'
                         border='left'
                         dense
                         text
                         type='error'
                >

                    <v-row align='center'>
                        <v-col class='grow'>
                            لطفا تمام فیلدهای اجباری را پر کنید
                        </v-col>
                        <v-col class='shrink'>
                            <v-btn icon
                                   @click='showInvalidMessageDialog = false'>
                                <v-icon color='black'>mdi-close</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                </v-alert>
            </v-sheet>
        </v-dialog>
    </v-form>
</template>

<script>
import {mapActions, mapState} from "vuex";
import InfoAlert from '@/components/Alerts/InfoAlert';
import axios from "axios";
import {createSupportRequest} from "@/plugins/createSupportRequest";

export default {
    name: "requiredInfo",
    components: {
        InfoAlert
    },
    props: {
        apartment: Object,
        step: Number,
        goToStep: Function,
    },
    model: {
        prop: 'apartment',
        event: 'updateApartment'
    },
    data() {
        return {
            rules: {
                type: [
                    v => !!v || 'نوع مجموعه اجباری میباشد'
                ],
                title: [
                    v => !!v || 'عنوان اجباری میباشد'
                ],
                practical: [
                    v => !!v || 'کاربری اجباری میباشد'
                ],
                province: [
                    v => !!v || 'استان اجباری میباشد'
                ],
                city: [
                    v => !!v || 'شهر اجباری میباشد'
                ],
                address: [
                    v => !!v || 'آدرس اجباری میباشد'
                ],
                number: [
                    v => !!v || 'پلاک اجباری میباشد (لطفا کیبورد خود را انگلیسی کنید)'
                ],
                postalCode: [
                    v => !v ? true : v.match(/\b(?!(\d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/) ? true : 'کد پستی صحیح نمیباشد'
                ],
                floorCount: [
                    v => !!v || 'تعداد طبقه ها اجباری میباشد',
                    v => v % 1 === 0 ? true : 'نمی توان از عدد اعشاری اسفاده کرد'
                ],
                unitCount: [
                    v => !!v || 'تعداد کل واحدها اجباری میباشد',
                    v => v < 1 ? 'از اعداد منفی یا عدد ۰ نمی توان استفاده کنید' : true,
                    v => v % 1 === 0 ? true : 'نمی توان از عدد اعشاری اسفاده کرد'
                ],
                pieceCount: [
                    v => !!v || 'تعداد کل قطعه ها اجباری میباشد',
                    v => v < 1 ? 'از اعداد منفی یا عدد ۰ نمی توان استفاده کنید' : true,
                    v => v % 1 === 0 ? true : 'نمی توان از عدد اعشاری اسفاده کرد'
                ]
            },
            disabled: false,
            validRequiredInfo: true,
            loadingSubmitRequiredInfo: false,
            showInvalidMessageDialog: false,

            provinceOptions: [],
            typeOptions: [
                {title: 'ساختمان', key: 'APARTMENT'},
                {title: 'شهرک ویلایی', key: 'TOWN'},
                {title: 'برج', key: 'TOWER'},
                {title: 'مجتمع', key: 'COMPLEX'}
            ],
            practicalOptions: [
                {title: 'مسکونی', key: 'RESIDENTIAL'},
                {title: 'تجاری', key: 'COMMERCIAL'},
                {title: 'خدماتی', key: 'SERVICES'},
                {title: 'اداری', key: 'OFFICIAL'},
                {title: 'صنعتی', key: 'INDUSTRIAL'},
                {title: 'تفریحی', key: 'ENTERTAINMENT'},
                {title: 'کشاورزی', key: 'AGRICULTURAL'}
            ],
            error: {
                dialog: false,
                response: null
            },
        }
    },
    methods: {

        validateApartmentInfo() {
            this.$refs['require-info-form'].validate();
            if (!this.$refs['require-info-form'].validate()) {
                this.showInvalidMessageDialog = true;
            }
            this.showNavigationBar();
        },

        async submitRequiredApartmentInfo() {
            this.loadingSubmitRequiredInfo = true;
            if (this.apartment._id) {
                this.showNavigationBar();
                this.goToStep(this.step + 1);
            } else {
                await axios
                    .post('/api/apartments/required_info', this.apartment)
                    .then(async (res) => {
                        let apartment = res.data.apartment;
                        this.setRole({[apartment._id]: 'MANAGER'});

                        let message = 'اطلاعات مجموعه ' + this.apartment.title + ' ثبت شد.';
                        await this.$snackbar.showMessage({content: message, color: 'success'});

                        await createSupportRequest(null, {
                            title: `ارتباط با پشتیبانی / مجموعه ${apartment.title}`,
                            apartment: apartment._id,
                            text: message,
                            type: 'APARTMENT_INFO'
                        }).then(async res => {

                            localStorage.setItem('supportRequest_id', res.data.supportRequest._id);
                            apartment.supportRequest = res.data.supportRequest._id;
                            await axios.put(`/api/apartments/${apartment._id}/assign_supportRequest/${apartment.supportRequest}`)
                                .then(async () => {
                                    let message = 'درخواست پشتیبانی مجموعه' + apartment.title + ' ثبت شد.';
                                    await this.$snackbar.showMessage({content: message, color: 'success'});
                                }).catch(async err => {
                                    console.error(err);
                                    let message = 'ایجاد درخواست پشتیبانی مجموعه' + apartment.title + ' با خطا مواجه شد.';
                                    await this.$snackbar.showMessage({content: message, color: 'error'});
                                });

                        });


                        this.showNavigationBar();
                        await this.$emit('updateApartment', {...apartment});

                        this.goToStep(this.step + 1);
                        // setTimeout(() => this.$vuetify.goTo(this.$refs['step-3'], { offset: 10 }), 300);

                    })
                    .catch((err) => {
                        this.error = {
                            dialog: true,
                            response: err.response || null,
                        };
                        this.showNavigationBar();
                    });
            }

            this.loadingSubmitRequiredInfo = false;
        },

        async fetchProvinces() {
            await axios
                .get('/api/provinces')
                .then(res => {
                    this.provinceOptions = res.data.provinces;
                })
                .catch(err => {
                    console.error(err);
                });
        },

        hideNavigationBar() {
            this.showNavigation(false);
        },
        showNavigationBar() {
            this.showNavigation(true);
        },
        ...mapActions([
            'setRole',
            'showNavigation',
            'showBreadCrumbs',
            'setBreadCrumbsTemp'
        ])
    },
    computed: {
        cityOptions() {
            if (this.provinceOptions.length > 0 && this.apartment.province) {
                return this.provinceOptions.find(item => {
                    if (item._id === this.apartment.province) return item;
                }).cities;
            }
            return [];
        },

        ...mapState(['user', 'public_url'])
    },
    async created() {
        await this.fetchProvinces();
    }
}
</script>

<style scoped>

</style>